import { VehicleDetailsApplicationOutput } from './vehicle-details-application-output.model';
import { VehicleDetailsDocumentOutput } from './vehicle-details-document-output.model';


export class VehicleDetailsOutput implements IVehicleDetailsOutput {
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with 50 character limit */
    vehicle_number!: string;
    /** The vehicle name with 50 character limit */
    vehicle_name!: string;
    /** The vehicle category must be Movable or Immovable */
    vehicle_category!: string;
    /** The auto-generated id of the vehicle type master */
    vehicle_model_id!: number;
    /** The manufacturing date with 10 character limit */
    manufacture_date!: string;
    /** The vehicle special feature with 500 character limit */
    special_feature!: string;
    /** The vehicle description with 500 character limit */
    description!: string;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The purchase date with 10 character limit */
    purchase_date!: string;
    /** The first passing date with 10 character limit */
    first_passing_date!: string;
    /** The next passing date with 10 character limit */
    next_passing_date!: string;
    /** The next puc date with 10 character limit */
    next_puc_date!: string;
    /** The vehicle picture image with 2048 character limit */
    vehicle_picture!: string;
    /** The next service date with 10 character limit */
    next_service_date!: string;
    /** The next oil change date with 10 character limit */
    next_oil_change_date!: string;
    /** The next insurance date with 10 character limit */
    next_insurance_date!: string;
    /** The max speed of vehicle  with 10 character limit */
    max_speed!: number;
    /** The odometer of vehicle with 10 character limit */
    odometer!: number;
    /** The fuel consumption of vehicle with 10 character limit */
    fuel_consumption_based_on!: string;
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The input scaling of vehicle with 10 character limit */
    input_scaling!: string;
    /** The input scaling of vehicle with 10 character limit */
    output_scaling!: string;
    /** The register number of vehicle with 10 character limit */
    register_number!: string;
    /** The chassis number of vehicle with 10 character limit */
    chassis_number!: string;
    /** The chassis number of vehicle with 10 character limit */
    cylinder_id!: string;
    /** The selling date with 10 character limit */
    selling_date!: string;
    /** The owner name of vehicle 500 character limit */
    owner_name!: string;
    /** The owner contact number 50 character limit */
    owner_contact_number!: string;
    /** The minimum working hour 50 character limit */
    minimum_working_hours!: number;
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id!: number;
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    vehicle_details_application!: VehicleDetailsApplicationOutput[];
    vehicle_details_document!: VehicleDetailsDocumentOutput[];
    status!: number;

    constructor(data?: IVehicleDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_number = _data["vehicle_number"];
            this.vehicle_name = _data["vehicle_name"];
            this.vehicle_category = _data["vehicle_category"];
            this.vehicle_model_id = _data["vehicle_model_id"];
            this.manufacture_date = _data["manufacture_date"];
            this.special_feature = _data["special_feature"];
            this.description = _data["description"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.purchase_date = _data["purchase_date"];
            this.first_passing_date = _data["first_passing_date"];
            this.next_passing_date = _data["next_passing_date"];
            this.next_puc_date = _data["next_puc_date"];
            this.vehicle_picture = _data["vehicle_picture"];
            this.next_service_date = _data["next_service_date"];
            this.next_oil_change_date = _data["next_oil_change_date"];
            this.next_insurance_date = _data["next_insurance_date"];
            this.max_speed = _data["max_speed"];
            this.odometer = _data["odometer"];
            this.fuel_consumption_based_on = _data["fuel_consumption_based_on"];
            this.alert_group_id = _data["alert_group_id"];
            this.input_scaling = _data["input_scaling"];
            this.output_scaling = _data["output_scaling"];
            this.register_number = _data["register_number"];
            this.chassis_number = _data["chassis_number"];
            this.cylinder_id = _data["cylinder_id"];
            this.selling_date = _data["selling_date"];
            this.owner_name = _data["owner_name"];
            this.owner_contact_number = _data["owner_contact_number"];
            this.minimum_working_hours = _data["minimum_working_hours"];
            this.vehicle_type_id = _data["vehicle_type_id"];
            this.vehicle_company_id = _data["vehicle_company_id"];
            this.company_details_id = _data["company_details_id"];
            if (Array.isArray(_data["vehicle_details_application"])) {
                this.vehicle_details_application = [] as any;
                for (let item of _data["vehicle_details_application"])
                    this.vehicle_details_application!.push(VehicleDetailsApplicationOutput.fromJS(item));
            }
            if (Array.isArray(_data["vehicle_details_document"])) {
                this.vehicle_details_document = [] as any;
                for (let item of _data["vehicle_details_document"])
                    this.vehicle_details_document!.push(VehicleDetailsDocumentOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_number"] = this.vehicle_number;
        data["vehicle_name"] = this.vehicle_name;
        data["vehicle_category"] = this.vehicle_category;
        data["vehicle_model_id"] = this.vehicle_model_id;
        data["manufacture_date"] = this.manufacture_date;
        data["special_feature"] = this.special_feature;
        data["description"] = this.description;
        data["branch_detail_id"] = this.branch_detail_id;
        data["purchase_date"] = this.purchase_date;
        data["first_passing_date"] = this.first_passing_date;
        data["next_passing_date"] = this.next_passing_date;
        data["next_puc_date"] = this.next_puc_date;
        data["vehicle_picture"] = this.vehicle_picture;
        data["next_service_date"] = this.next_service_date;
        data["next_oil_change_date"] = this.next_oil_change_date;
        data["next_insurance_date"] = this.next_insurance_date;
        data["max_speed"] = this.max_speed;
        data["odometer"] = this.odometer;
        data["fuel_consumption_based_on"] = this.fuel_consumption_based_on;
        data["alert_group_id"] = this.alert_group_id;
        data["input_scaling"] = this.input_scaling;
        data["output_scaling"] = this.output_scaling;
        data["register_number"] = this.register_number;
        data["chassis_number"] = this.chassis_number;
        data["cylinder_id"] = this.cylinder_id;
        data["selling_date"] = this.selling_date;
        data["owner_name"] = this.owner_name;
        data["owner_contact_number"] = this.owner_contact_number;
        data["minimum_working_hours"] = this.minimum_working_hours;
        data["vehicle_type_id"] = this.vehicle_type_id;
        data["vehicle_company_id"] = this.vehicle_company_id;
        data["company_details_id"] = this.company_details_id;
        if (Array.isArray(this.vehicle_details_application)) {
            data["vehicle_details_application"] = [];
            for (let item of this.vehicle_details_application)
                data["vehicle_details_application"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicle_details_document)) {
            data["vehicle_details_document"] = [];
            for (let item of this.vehicle_details_document)
                data["vehicle_details_document"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleDetailsOutput {
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with 50 character limit */
    vehicle_number: string;
    /** The vehicle name with 50 character limit */
    vehicle_name: string;
    /** The vehicle category must be Movable or Immovable */
    vehicle_category: string;
    /** The auto-generated id of the vehicle type master */
    vehicle_model_id: number;
    /** The manufacturing date with 10 character limit */
    manufacture_date: string;
    /** The vehicle special feature with 500 character limit */
    special_feature: string;
    /** The vehicle description with 500 character limit */
    description: string;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The purchase date with 10 character limit */
    purchase_date: string;
    /** The first passing date with 10 character limit */
    first_passing_date: string;
    /** The next passing date with 10 character limit */
    next_passing_date: string;
    /** The next puc date with 10 character limit */
    next_puc_date: string;
    /** The vehicle picture image with 2048 character limit */
    vehicle_picture: string;
    /** The next service date with 10 character limit */
    next_service_date: string;
    /** The next oil change date with 10 character limit */
    next_oil_change_date: string;
    /** The next insurance date with 10 character limit */
    next_insurance_date: string;
    /** The max speed of vehicle  with 10 character limit */
    max_speed: number;
    /** The odometer of vehicle with 10 character limit */
    odometer: number;
    /** The fuel consumption of vehicle with 10 character limit */
    fuel_consumption_based_on: string;
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The input scaling of vehicle with 10 character limit */
    input_scaling: string;
    /** The input scaling of vehicle with 10 character limit */
    output_scaling: string;
    /** The register number of vehicle with 10 character limit */
    register_number: string;
    /** The chassis number of vehicle with 10 character limit */
    chassis_number: string;
    /** The chassis number of vehicle with 10 character limit */
    cylinder_id: string;
    /** The selling date with 10 character limit */
    selling_date: string;
    /** The owner name of vehicle 500 character limit */
    owner_name: string;
    /** The owner contact number 50 character limit */
    owner_contact_number: string;
    /** The minimum working hour 50 character limit */
    minimum_working_hours: number;
    /** The auto-generated id of the vehicle type master */
    vehicle_type_id: number;
    /** The auto-generated id of the vehicle company master */
    vehicle_company_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    vehicle_details_application: VehicleDetailsApplicationOutput[];
    vehicle_details_document: VehicleDetailsDocumentOutput[];
    status: number;
}

